import { useLeadForm } from "../hooks/useLeadForm";
import { WizardSidePanel } from "./wizard/WizardSidePanel";
import { ContactStep } from "./wizard/ContactStep";
import { BriefStep } from "./wizard/BriefStep";

export const LeadWizard = () => {
    const {
        step,
        form,
        submittingContact,
        submittingBrief,
        set,
        submitContact,
        goBack,
        submitBrief,
    } = useLeadForm();

    return (
        <section
            id="contact"
            data-testid="contact-section"
            className="relative py-24 sm:py-32"
        >
            <div className="max-w-5xl mx-auto px-5 sm:px-8">
                <div className="bg-black rounded-3xl border border-white/10 overflow-hidden shadow-[0_40px_100px_-30px_rgba(0,0,0,0.7)] grid lg:grid-cols-12">
                    <WizardSidePanel step={step} />

                    <div className="lg:col-span-7 p-8 sm:p-10">
                        {step === 1 && (
                            <ContactStep
                                form={form}
                                set={set}
                                submitting={submittingContact}
                                onContinue={submitContact}
                            />
                        )}
                        {step === 2 && (
                            <BriefStep
                                form={form}
                                set={set}
                                submitting={submittingBrief}
                                onBack={goBack}
                                onSubmit={submitBrief}
                            />
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};
